<div class="min-h-[85vh] lg:min-h-0">
    @if (loading()) {
        <div class="inner-page-wrapper mx-auto min-h-[730px]">Loading...</div>
    } @else {
        @if (data(); as d) {
            @if (errorText(); as error) {
                <p class="z-999 w-full bg-red py-8 text-center font-headline text-14 font-medium leading-27 text-white">
                    {{ error }}
                </p>
            }

            @if (d.currentStep) {
                @if (d.currentStep.showStepperMenu) {
                    <div class="mx-auto flex w-full max-w-[1280px] lg:h-[80px]">
                        @if (d.stepForStepper.length > 1 || onlyOneStep()) {
                            <div
                                class="w-full px-16 pt-16 lg:mx-auto lg:w-[60%] lg:px-[60px] lg:pt-40"
                                [ngClass]="[d.currentStep.showSidebar ? 'xl:pr-[120px]' : '']"
                            >
                                @if (!onlyOneStep()) {
                                    <div
                                        class="flex justify-center"
                                        [ngClass]="{
                                            hidden: identifier() === 'distribution',
                                        }"
                                    >
                                        @for (
                                            step of d.stepForStepper;
                                            track step;
                                            let index = $index;
                                            let last = $last;
                                            let first = $first
                                        ) {
                                            <button class="relative block" (click)="activateStepById(step.id)">
                                                <!-- stepper step line after first and before last circle-->
                                                @if (first || last) {
                                                    <span
                                                        class="top-7 absolute block h-2 w-48 lg:top-12"
                                                        [ngClass]="{ 'right-0': first || !last, 'left-0': last }"
                                                    ></span>
                                                }
                                                <!-- stepper step line after/before first and last end-->
                                                <!-- stepper step circle -->
                                                <span
                                                    class="relative block size-16 rounded-full text-center transition-all duration-300 ease-in-out lg:top-4"
                                                    [ngClass]="{
                                                        'center lg:m-auto': first || last,
                                                        'bg-accent': d.stepperIndex === index || d.stepperIndex > index,
                                                        'bg-grey-300': d.stepperIndex < index,
                                                    }"
                                                >
                                                    @if (d.stepperIndex > index) {
                                                        <span
                                                            class="bg-checkWhite relative -top-8 left-0 inline-block h-9 w-9"
                                                        ></span>
                                                    }
                                                    @if (d.stepperIndex <= index) {
                                                        <span class="hidden">
                                                            {{ index + 1 }}
                                                        </span>
                                                    }
                                                </span>
                                                <!-- stepper step circle end -->
                                                <!-- stepper step label desktop -->
                                                <p
                                                    class="text-light-text relative left-0 mt-10 hidden w-16 whitespace-nowrap text-10 uppercase lg:flex lg:justify-center"
                                                    [ngClass]="[
                                                        d.stepperIndex === index ? 'font-semibold' : '',
                                                        d.stepperIndex < index ? '' : '',
                                                        d.stepperIndex > index ? '' : '',
                                                        index === d.stepForStepper.length - 1 ? 'right-0' : '',
                                                        !first && !last ? 'text-center' : '',
                                                    ]"
                                                >
                                                    {{ step.label }}
                                                </p>
                                                <!-- stepper step label desktop end-->
                                            </button>
                                            <!-- stepper step line between circles -->
                                            @if (!last) {
                                                <div
                                                    class="relative h-2 top-7 lg:top-12 lg:max-w-60 lg:max-w-full w-full
                                                        {{ d.stepperIndex > index ? 'bg-accent' : '' }}
                                                        {{ d.stepperIndex <= index ? 'bg-grey-300' : '' }}
                                                "
                                                    [ngClass]="{
                                                        active: d.stepperIndex > index,
                                                        inactive: d.stepperIndex <= index,
                                                    }"
                                                ></div>
                                            }
                                            <!-- stepper step line between cicles end-->
                                        }
                                    </div>
                                }
                            </div>
                        }
                        <!-- sidebar bg in stepper row -->
                        @if (!d.stepForStepper.length) {
                            <div class="w-full max-w-[40%]"></div>
                        }
                        @if (d.currentStep.showSidebar) {
                            <div class="relative hidden max-w-[40%] bg-grey-100 lg:block lg:w-full">
                                @if (!completed()) {
                                    <div class="absolute h-full w-[50vw] bg-grey-100"></div>
                                }
                            </div>
                        }
                        <!-- sidebar bg in stepper row end-->
                    </div>
                }
                <div
                    class="mx-auto w-full max-w-[1440px]"
                    [ngClass]="{
                        'lg:flex lg:flex-row-reverse lg:justify-end': !completed() && d.currentStep.showSidebar,
                    }"
                >
                    <!-- sidebar -->
                    @if (!completed() && d.currentStep.showSidebar) {
                        <div
                            class="lg:w-[40%]lg:pb-8 relative bg-grey-100 px-24 pt-[18px] lg:min-h-[730px] lg:pl-[56px] lg:pt-0 xl:pr-0"
                        >
                            <div class="absolute hidden h-full w-[50vw] bg-grey-100 lg:block"></div>
                            <div
                                class="relative"
                                [ngClass]="{
                                    'lg:-mt-[40px]': d.currentStep.showStepperMenu,
                                    'lg:py-[40px]': !d.currentStep.showStepperMenu,
                                }"
                            >
                                <ng-content select="[global]" />
                            </div>
                        </div>
                    }
                    <!-- sidebar end-->
                    <!-- step content -->
                    <div
                        class="relative"
                        [ngClass]="{
                            'bg-white px-24 lg:w-[60%] 2xl:min-w-[904px] 2xl:max-w-[904px] 2xl:pl-[112px] 2xl:pr-[106px]':
                                !completed() && d.currentStep.showSidebar,
                            'lg:w-full lg:px-24': completed() || !d.currentStep.showSidebar,
                        }"
                    >
                        <div
                            class="absolute left-0 top-0 z-0 hidden h-full w-[800px] -translate-x-full bg-white lg:block"
                        ></div>
                        <ng-content />
                    </div>
                    <!-- step content end-->
                </div>
            }
        }
    }
</div>
